import { render, staticRenderFns } from "./r-package-dialog.vue?vue&type=template&id=337f852e&scoped=true"
import script from "./r-package-dialog.vue?vue&type=script&lang=js"
export * from "./r-package-dialog.vue?vue&type=script&lang=js"
import style0 from "./r-package-dialog.vue?vue&type=style&index=0&id=337f852e&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "337f852e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('337f852e')) {
      api.createRecord('337f852e', component.options)
    } else {
      api.reload('337f852e', component.options)
    }
    module.hot.accept("./r-package-dialog.vue?vue&type=template&id=337f852e&scoped=true", function () {
      api.rerender('337f852e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/redactor/views/package/r-package-dialog.vue"
export default component.exports